(() => {
  'use strict';

  if (window.SkaiiySearchIntelligenceReady) return;
  window.SkaiiySearchIntelligenceReady = true;

  /* SKAIIY SEARCH INTELLIGENCE v2.2 - query-first + conditional family personalization */
  const STORAGE_KEY = 'skaiiy_intelligence_v1';
  const SEARCH_CACHE_TTL = 5 * 60 * 1000;
  const BESTSELLER_CACHE_TTL = 10 * 60 * 1000;
  const responseCache = new Map();
  const bestSellerCache = new Map();

  const SERIES_RULES = [
    { key: 'jjk', label: 'JJK', canonical: 'Jujutsu Kaisen', nameAliases: ['jujutsu kaisen', 'jjk'], aliases: ['jujutsu kaisen', 'jjk', 'gojo', 'satoru gojo', 'gojo satoru', 'sukuna', 'ryomen sukuna', 'itadori', 'yuji itadori', 'megumi', 'megumi fushiguro', 'nobara', 'nobara kugisaki', 'toji', 'toji fushiguro', 'yuta', 'yuta okkotsu', 'geto', 'suguru geto'] },
    { key: 'csm', label: 'CSM', canonical: 'Chainsaw Man', nameAliases: ['chainsaw man', 'chainsawman', 'csm'], aliases: ['chainsaw man', 'chainsawman', 'csm', 'denji', 'makima', 'power', 'aki hayakawa', 'pochita'] },
    { key: 'aot', label: 'AOT', canonical: 'Attack on Titan', nameAliases: ['attack on titan', 'aot'], aliases: ['attack on titan', 'aot', 'eren', 'eren yeager', 'mikasa', 'mikasa ackerman', 'levi', 'levi ackerman', 'survey corps', 'scout regiment'] },
    { key: 'hxh', label: 'HXH', canonical: 'Hunter x Hunter', nameAliases: ['hunter x hunter', 'hunter hunter', 'hxh'], aliases: ['hunter x hunter', 'hunter hunter', 'hxh', 'gon', 'gon freecss', 'killua', 'killua zoldyck', 'kurapika', 'hisoka'] },
    { key: 'naruto', label: 'NARUTO', canonical: 'Naruto', nameAliases: ['naruto'], aliases: ['naruto', 'uzumaki', 'naruto uzumaki', 'sasuke', 'sasuke uchiha', 'itachi', 'itachi uchiha', 'kakashi', 'akatsuki'] },
    { key: 'demon-slayer', label: 'DEMON SLAYER', canonical: 'Demon Slayer', nameAliases: ['demon slayer', 'kimetsu no yaiba', 'kny'], aliases: ['demon slayer', 'kimetsu no yaiba', 'kny', 'tanjiro', 'nezuko', 'zenitsu', 'inosuke', 'rengoku', 'tengen uzui'] },
    { key: 'one-piece', label: 'ONE PIECE', canonical: 'One Piece', nameAliases: ['one piece'], aliases: ['one piece', 'luffy', 'monkey d luffy', 'zoro', 'roronoa zoro', 'nami', 'sanji', 'boa hancock', 'chopper'] },
    { key: 'bleach', label: 'BLEACH', canonical: 'Bleach', nameAliases: ['bleach'], aliases: ['bleach', 'ichigo', 'ichigo kurosaki', 'rukia', 'aizen'] },
    { key: 'dragon-ball', label: 'DRAGON BALL', canonical: 'Dragon Ball', nameAliases: ['dragon ball', 'dragon ball z', 'dragonball', 'dragonball z', 'dbz'], aliases: ['dragon ball', 'dragon ball z', 'dragonball', 'dragonball z', 'dbz', 'goku', 'vegeta', 'gohan', 'trunks'] },
    { key: 'mha', label: 'MHA', canonical: 'My Hero Academia', nameAliases: ['my hero academia', 'boku no hero academia', 'mha'], aliases: ['my hero academia', 'boku no hero academia', 'mha', 'deku', 'izuku midoriya', 'bakugo', 'todoroki'] },
    { key: 'black-clover', label: 'BLACK CLOVER', canonical: 'Black Clover', nameAliases: ['black clover'], aliases: ['black clover', 'asta', 'yuno', 'noelle silva'] },
    { key: 'tokyo-revengers', label: 'TOKYO REVENGERS', canonical: 'Tokyo Revengers', nameAliases: ['tokyo revengers'], aliases: ['tokyo revengers', 'mikey', 'manjiro sano', 'draken'] },
    { key: 'death-note', label: 'DEATH NOTE', canonical: 'Death Note', nameAliases: ['death note'], aliases: ['death note', 'light yagami', 'ryuk', 'misa amane'] },
    { key: 'pokemon', label: 'POKEMON', canonical: 'Pokemon', nameAliases: ['pokemon', 'pokémon'], aliases: ['pokemon', 'pokémon', 'pikachu', 'snorlax', 'gengar', 'umbreon', 'charizard'] },
    { key: 'blue-lock', label: 'BLUE LOCK', canonical: 'Blue Lock', nameAliases: ['blue lock', 'bluelock'], aliases: ['blue lock', 'bluelock', 'isagi', 'yoichi isagi', 'bachira', 'nagi', 'rin itoshi'] },
    { key: 'haikyuu', label: 'HAIKYUU', canonical: 'Haikyuu', nameAliases: ['haikyuu', 'haikyu'], aliases: ['haikyuu', 'haikyu', 'hinata shoyo', 'kageyama'] },
    { key: 'solo-leveling', label: 'SOLO LEVELING', canonical: 'Solo Leveling', nameAliases: ['solo leveling'], aliases: ['solo leveling', 'sung jinwoo', 'sung jin woo', 'jinwoo'] },
    { key: 'spy-family', label: 'SPY X FAMILY', canonical: 'Spy x Family', nameAliases: ['spy x family', 'spy family'], aliases: ['spy x family', 'spy family', 'anya', 'anya forger', 'yor forger', 'loid forger'] },
    { key: 'dandadan', label: 'DANDADAN', canonical: 'Dandadan', nameAliases: ['dandadan', 'dan da dan'], aliases: ['dandadan', 'dan da dan', 'momo ayase', 'momo', 'okarun', 'ken takakura', 'aira shiratori', 'jiji', 'seiko ayase', 'turbo granny'] },
    { key: 'berserk', label: 'BERSERK', canonical: 'Berserk', nameAliases: ['berserk'], aliases: ['berserk', 'guts', 'griffith', 'casca', 'skull knight'] },
    { key: 'overwatch', label: 'OVERWATCH', canonical: 'Overwatch', nameAliases: ['overwatch'], aliases: ['overwatch', 'd.va', 'd va', 'dva', 'd.va overwatch', 'dva overwatch', 'mercy overwatch', 'tracer overwatch', 'widowmaker overwatch'] },
    { key: 'hello-kitty', label: 'HELLO KITTY', canonical: 'Hello Kitty', nameAliases: ['hello kitty', 'hellokitty'], aliases: ['hello kitty', 'hellokitty'] },
    { key: 'sanrio', label: 'SANRIO', canonical: 'Sanrio', nameAliases: ['sanrio'], aliases: ['sanrio', 'kuromi', 'cinnamoroll', 'my melody', 'pompompurin', 'pochacco', 'keroppi'] }
  ];

  const FAMILY_RULES = [
    { key: 'tshirt', label: 'T-shirts', query: 't-shirt', aliases: ['t-shirt', 't shirt', 'tshirt', 'tshirts', 'tee', 'tees', 'vintage t-shirt', 'vintage t shirt', 'vintage tee'] },
    { key: 'hoodie', label: 'Hoodies', query: 'hoodie', aliases: ['hoodie', 'hoodies', 'hooded sweatshirt'] },
    { key: 'sweater', label: 'Sweaters', query: 'sweater', aliases: ['sweater', 'sweaters', 'sweatshirt', 'sweatshirts', 'crewneck', 'crew neck'] },
    { key: 'cosplay', label: 'Cosplays', query: 'cosplay', aliases: ['cosplay', 'cosplays', 'costume', 'costumes', 'kigurumi', 'bodysuit'] },
    { key: 'figures', label: 'Figures', query: 'figure', aliases: ['figure', 'figures', 'figurine', 'figurines', 'statue', 'collectible figure'] },
    { key: 'jersey', label: 'Jerseys', query: 'jersey', aliases: ['jersey', 'jerseys', 'soccer jersey', 'football jersey'] },
    { key: 'pajama', label: 'Pajamas', query: 'pajama', aliases: ['pajama', 'pajamas', 'pyjama', 'pyjamas', 'sleepwear', 'onesie', 'onesies'] },
    { key: 'pants', label: 'Pants', query: 'pants', aliases: ['pants', 'trousers', 'joggers', 'sweatpants', 'cargo pants'] },
    { key: 'slippers', label: 'Slippers', query: 'slippers', aliases: ['slipper', 'slippers'] },
    { key: 'socks', label: 'Socks', query: 'socks', aliases: ['sock', 'socks'] },
    { key: 'accessories', label: 'Accessories', query: 'accessories', aliases: ['accessory', 'accessories', 'wig', 'wigs', 'mask', 'masks', 'hat', 'hats', 'cap', 'gloves'] }
  ];

  const normalize = value => String(value == null ? '' : value)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&amp;/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const tokenize = value => normalize(value).split(' ').filter(Boolean);
  const unique = values => Array.from(new Set(values.filter(Boolean)));
  const phraseIn = (text, phrase) => (` ${normalize(text)} `).includes(` ${normalize(phrase)} `);
  const compact = value => normalize(value).replace(/\s+/g, '');

  const QUERY_STOP_WORDS = new Set([
    'the', 'and', 'for', 'with', 'from', 'of', 'a', 'an', 'to', 'in',
    'anime', 'manga', 'official', 'style', 'premium', 'new', 'shop', 'product'
  ]);

  const FAMILY_QUERY_TOKENS = new Set(
    FAMILY_RULES.flatMap(rule => rule.aliases.flatMap(alias => tokenize(alias)))
      .filter(token => token.length > 1)
  );

  const meaningfulQueryTokens = value =>
    tokenize(value).filter(token => token.length > 1 && !QUERY_STOP_WORDS.has(token));

  const anchorQueryTokens = value =>
    meaningfulQueryTokens(value).filter(token => !FAMILY_QUERY_TOKENS.has(token));

  const safeParse = (value, fallback) => {
    try {
      const parsed = JSON.parse(value);
      return parsed == null ? fallback : parsed;
    } catch (error) {
      return fallback;
    }
  };

  const readState = () => {
    const base = {
      version: 1,
      views: [],
      catalog: {},
      familyWeights: {},
      tokenWeights: {},
      seriesWeights: {},
      queryHistory: [],
      signals: {},
      updatedAt: Date.now()
    };
    try {
      return Object.assign(base, safeParse(localStorage.getItem(STORAGE_KEY), {}));
    } catch (error) {
      return base;
    }
  };

  const writeState = state => {
    state.queryHistory = Array.isArray(state.queryHistory) ? state.queryHistory.slice(0, 60) : [];
    state.updatedAt = Date.now();
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (error) {}
  };

  const addWeight = (object, key, amount, cap = 80) => {
    if (!key || key === 'unknown') return;
    object[key] = Math.min(cap, Math.max(0, Number(object[key] || 0) + Number(amount || 0)));
  };

  const classifySeriesText = value => {
    const text = normalize(value);
    if (!text) return null;
    for (const rule of SERIES_RULES) {
      if (rule.aliases.some(alias => phraseIn(text, alias))) return rule;
    }
    return null;
  };

  const classifyFamilyText = value => {
    const text = normalize(value);
    if (!text) return null;
    for (const rule of FAMILY_RULES) {
      if (rule.aliases.some(alias => phraseIn(text, alias))) return rule;
    }
    return null;
  };

  const familyRule = key => FAMILY_RULES.find(item => item.key === key) || null;
  const seriesRule = key => SERIES_RULES.find(item => item.key === key) || null;

  const isSeriesNameQuery = (query, series, explicitFamily = null) => {
    if (!series) return false;

    /* Remove category words from the intent check so searches such as
       "Naruto T-shirt" still count as an anime-name query. */
    const coreTokens = anchorQueryTokens(query);
    const core = normalize(coreTokens.join(' ') || query);
    if (!core) return false;

    const names = unique([
      ...(Array.isArray(series.nameAliases) ? series.nameAliases : []),
      series.canonical,
      series.label,
      series.key
    ]).map(normalize);

    return names.includes(core);
  };

  const preferredFamily = (state, useHistory = true) => {
    if (!useHistory) return null;
    const recent = Array.isArray(state.views) ? state.views : [];
    const recentFamily = recent.find(item => item && item.family && item.family !== 'unknown')?.family || '';
    const entries = Object.entries(state.familyWeights || {})
      .filter(([key]) => key && key !== 'unknown')
      .sort((a, b) => Number(b[1] || 0) - Number(a[1] || 0));
    if (!entries.length) return recentFamily ? familyRule(recentFamily) : null;
    const top = entries[0];
    if (recentFamily && Number(top[1] || 0) < 2.5) return familyRule(recentFamily);
    return familyRule(top[0]) || (recentFamily ? familyRule(recentFamily) : null);
  };

  const getQueryContext = (query, options = {}) => {
    const state = readState();
    const series = classifySeriesText(query);
    const explicitFamily = classifyFamilyText(query);
    const historyFamily = preferredFamily(state, options.useHistory !== false);

    const canonicalSeries = series ? series.canonical : '';
    const canonicalFamily = explicitFamily ? explicitFamily.query : '';
    const seriesNameQuery = isSeriesNameQuery(query, series, explicitFamily);

    /* History may refine a recognized anime/character/entity search, but it
       can never replace the query. Explicit category words always win. */
    const canUseHistoryFamily = Boolean(
      series && !explicitFamily && historyFamily && options.useHistory !== false
    );
    const effectiveFamily = explicitFamily || (canUseHistoryFamily ? historyFamily : null);

    const canonicalQuery = unique([
      canonicalSeries || String(query || '').trim(),
      canonicalFamily
    ]).join(' ').trim() || String(query || '').trim();

    return {
      rawQuery: String(query || '').trim(),
      normalizedQuery: normalize(query),
      compactQuery: compact(query),
      queryTokens: meaningfulQueryTokens(query),
      anchorTokens: anchorQueryTokens(query),
      seriesKey: series?.key || '',
      seriesLabel: series?.label || '',
      seriesCanonical: canonicalSeries,
      seriesNameQuery,
      queryIntent: series ? (seriesNameQuery ? 'series-name' : 'series-entity') : (explicitFamily ? 'family' : 'literal'),
      explicitFamilyKey: explicitFamily?.key || '',
      explicitFamilyLabel: explicitFamily?.label || '',
      preferredFamilyKey: historyFamily?.key || '',
      preferredFamilyLabel: historyFamily?.label || '',
      effectiveFamilyKey: effectiveFamily?.key || '',
      effectiveFamilyLabel: effectiveFamily?.label || '',
      canonicalQuery,
      usedHistoryFamily: Boolean(canUseHistoryFamily),
      /* Cold-start anime discovery: when the shopper has no learned product-family
         preference yet and types only an anime/series name, bestseller rank may
         order products INSIDE that anime. It never brings another anime into the
         result pool and it never overrides an explicit category word. */
      coldStartAnimeBestsellers: Boolean(
        series && seriesNameQuery && !explicitFamily && !historyFamily
      ),
      state
    };
  };

  const imageFromProduct = p => {
    const f = p?.featured_image;
    if (typeof f === 'string') return f;
    return f?.url || f?.src || p?.image?.src || p?.image || p?.images?.[0]?.src || p?.images?.[0] || '';
  };

  const productKey = p => String(p?.id || p?.handle || p?.url || '');

  const normalizeProduct = (p, source = 'search', sourceIndex = 0) => {
    const title = String(p?.title || '');
    const type = String(p?.product_type || p?.type || '');
    const tags = Array.isArray(p?.tags) ? p.tags.join(' ') : String(p?.tags || '');
    const series = classifySeriesText([title, type, tags].join(' '));
    const family = classifyFamilyText([type, tags, title].join(' '));
    const rawPrice = p?.price_min ?? p?.price ?? p?.variants?.[0]?.price ?? '';
    const priceVaries = Boolean(p?.price_varies || (Array.isArray(p?.variants) && p.variants.length > 1 && new Set(p.variants.map(v => String(v.price))).size > 1));

    return {
      id: String(p?.id || ''),
      handle: String(p?.handle || ''),
      title,
      url: String(p?.url || (p?.handle ? `/products/${p.handle}` : '#')),
      image: imageFromProduct(p),
      price: rawPrice == null ? '' : String(rawPrice),
      price_varies: priceVaries,
      type,
      vendor: String(p?.vendor || ''),
      tags,
      series: series?.key || '',
      family: family?.key || '',
      source,
      sourceIndex,
      bestSeller: Boolean(p?.bestSeller),
      bestSellerRank: Number.isFinite(Number(p?.bestSellerRank)) ? Number(p.bestSellerRank) : null
    };
  };

  const cachedFetchJson = async (url, signal, ttl = SEARCH_CACHE_TTL) => {
    const now = Date.now();
    const cached = responseCache.get(url);
    if (cached && now - cached.ts < ttl) return cached.data;
    const response = await fetch(url, { signal, headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
    const data = await response.json();
    responseCache.set(url, { ts: now, data });
    return data;
  };

  const fetchPredictive = async (query, signal, limit = 10) => {
    const root = window.Shopify?.routes?.root || '/';
    const encoded = encodeURIComponent(query);
    try {
      const url = `${root}search/suggest.json?q=${encoded}&resources[type]=product&resources[limit]=${Math.min(10, Math.max(4, limit))}&resources[options][unavailable_products]=last`;
      const data = await cachedFetchJson(url, signal);
      return data?.resources?.results?.products || [];
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      return [];
    }
  };

  const fetchSearch = async (query, signal, limit = 20) => {
    const root = window.Shopify?.routes?.root || '/';
    const encoded = encodeURIComponent(query);
    try {
      const url = `${root}search.json?q=${encoded}&type=product&options[unavailable_products]=last&limit=${Math.min(50, Math.max(10, limit))}`;
      const data = await cachedFetchJson(url, signal);
      return data?.products || [];
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      return [];
    }
  };

  const fetchBestSellers = async (requestedHandle, signal) => {
    const handles = unique([requestedHandle, 'best-sellers', 'bestsellers']).filter(Boolean);
    const root = window.Shopify?.routes?.root || '/';

    for (const handle of handles) {
      const cacheKey = normalize(handle).replace(/ /g, '-');
      const cached = bestSellerCache.get(cacheKey);
      if (cached && Date.now() - cached.ts < BESTSELLER_CACHE_TTL) return cached.products;
      try {
        const url = `${root}collections/${encodeURIComponent(handle)}/products.json?limit=250`;
        const response = await fetch(url, { signal, headers: { Accept: 'application/json' } });
        if (!response.ok) continue;
        const data = await response.json();
        const products = (data?.products || []).map((product, index) => Object.assign({}, product, {
          bestSeller: true,
          bestSellerRank: index
        }));
        if (products.length) {
          bestSellerCache.set(cacheKey, { ts: Date.now(), products });
          return products;
        }
      } catch (error) {
        if (error?.name === 'AbortError') throw error;
      }
    }
    return [];
  };

  const getQueryRelevance = (product, context) => {
    const title = normalize(product.title);
    const metadata = normalize([product.title, product.type, product.tags, product.vendor].join(' '));
    const query = context.normalizedQuery;
    const queryCompact = context.compactQuery || compact(context.rawQuery);
    const titleCompact = compact(product.title);
    const tokens = context.queryTokens || meaningfulQueryTokens(context.rawQuery);
    const anchors = context.anchorTokens || anchorQueryTokens(context.rawQuery);

    const tokenMatches = (text, token) =>
      (` ${text} `).includes(` ${token} `) || (token.length >= 3 && text.includes(token));

    const titleTokenHits = tokens.filter(token => tokenMatches(title, token)).length;
    const metadataTokenHits = tokens.filter(token => tokenMatches(metadata, token)).length;
    const titleCoverage = tokens.length ? titleTokenHits / tokens.length : 0;
    const metadataCoverage = tokens.length ? metadataTokenHits / tokens.length : 0;

    const anchorTitleHits = anchors.filter(token => tokenMatches(title, token)).length;
    const anchorMetadataHits = anchors.filter(token => tokenMatches(metadata, token)).length;
    const anchorHits = Math.max(anchorTitleHits, anchorMetadataHits);
    const anchorCoverage = anchors.length ? anchorHits / anchors.length : 0;

    let tier = 0;
    let lexical = 0;

    if (query && title === query) {
      tier = 100;
      lexical = 1600;
    } else if (query && title.startsWith(`${query} `)) {
      tier = 98;
      lexical = 1500;
    } else if (query && title.includes(query)) {
      tier = 96;
      lexical = 1420;
    } else if (queryCompact.length >= 3 && titleCompact.includes(queryCompact)) {
      /* D.Va, d va, DVA and other punctuation/case variants are equivalent. */
      tier = 95;
      lexical = 1380;
    } else if (tokens.length && titleCoverage === 1) {
      tier = 92;
      lexical = 1260;
    } else if (tokens.length && metadataCoverage === 1) {
      tier = 86;
      lexical = 1120;
    } else if (titleCoverage >= 0.66) {
      tier = 76;
      lexical = Math.round(900 * titleCoverage);
    } else if (metadataCoverage >= 0.66) {
      tier = 70;
      lexical = Math.round(760 * metadataCoverage);
    } else if (titleCoverage > 0) {
      tier = 58;
      lexical = Math.round(520 * titleCoverage);
    } else if (metadataCoverage > 0) {
      tier = 48;
      lexical = Math.round(360 * metadataCoverage);
    }

    const literalTier = tier;
    const titleMatched = Boolean(
      (query && title.includes(query)) ||
      (queryCompact.length >= 3 && titleCompact.includes(queryCompact)) ||
      titleTokenHits > 0
    );

    /* Semantic aliases can discover candidates, but can never outrank a
       stronger literal/normalized query match. */
    if (context.seriesKey && product.series === context.seriesKey) {
      const semanticTier =
        context.explicitFamilyKey && product.family === context.explicitFamilyKey ? 84 : 80;
      tier = Math.max(tier, semanticTier);
      lexical += context.explicitFamilyKey && product.family === context.explicitFamilyKey ? 280 : 220;
    }

    /* A category word such as "cosplay" is a refinement, not a substitute for
       the character/series words the customer typed. */
    if (context.explicitFamilyKey && product.family === context.explicitFamilyKey) {
      if (!anchors.length || anchorHits > 0) {
        tier = Math.max(tier, anchors.length ? 62 : 72);
        lexical += 120;
      }
    }

    return {
      tier,
      lexical,
      titleCoverage,
      metadataCoverage,
      anchorHits,
      anchorCoverage,
      literalTier,
      titleMatched
    };
  };

  const scoreCandidate = (product, context) => {
    const relevance = getQueryRelevance(product, context);
    let score = relevance.lexical;

    if (context.explicitFamilyKey && product.family === context.explicitFamilyKey) score += 32;
    if (context.seriesKey && product.series === context.seriesKey) score += 24;

    /* History is not a relevance signal. It only identifies the preferred
       product family after the candidate has already matched the query. */
    if (
      context.usedHistoryFamily &&
      context.preferredFamilyKey &&
      product.family === context.preferredFamilyKey
    ) {
      score += 18;
    }

    /* Endpoint ordering only breaks ties inside the same relevance tier. */
    if (product.source === 'predictive') score += Math.max(0, 7 - product.sourceIndex * 0.35);
    if (product.source === 'raw-search') score += Math.max(0, 6 - product.sourceIndex * 0.25);
    if (product.source === 'normalized') score += Math.max(0, 5 - product.sourceIndex * 0.20);
    if (product.source === 'compact') score += Math.max(0, 4 - product.sourceIndex * 0.15);
    if (product.source === 'canonical') score += Math.max(0, 3 - product.sourceIndex * 0.10);
    if (product.source === 'history-refinement') score += Math.max(0, 4 - product.sourceIndex * 0.12);
    if (product.source === 'history-canonical') score += Math.max(0, 3 - product.sourceIndex * 0.10);

    return { score, relevance };
  };

  const buildQueryVariants = context => {
    const variants = [];
    const push = (value, source) => {
      const query = String(value || '').trim();
      if (!query) return;
      const dedupeKey = query.toLowerCase();
      if (variants.some(item => String(item.query).trim().toLowerCase() === dedupeKey)) return;
      variants.push({ query, source });
    };

    push(context.rawQuery, 'raw-search');

    const normalizedRaw = normalize(context.rawQuery);
    const rawLower = String(context.rawQuery || '').trim().toLowerCase();
    if (normalizedRaw && normalizedRaw !== rawLower) push(normalizedRaw, 'normalized');

    const compactRaw = compact(context.rawQuery);
    if (compactRaw.length >= 3 && compactRaw !== normalizedRaw) push(compactRaw, 'compact');

    if (context.seriesCanonical && normalize(context.seriesCanonical) !== normalize(context.rawQuery)) {
      push(context.seriesCanonical, 'canonical');
    }

    if (context.seriesCanonical && context.explicitFamilyKey) {
      const family = familyRule(context.explicitFamilyKey);
      push(`${context.seriesCanonical} ${family?.query || ''}`.trim(), 'semantic-family');
    }

    /* When an anime/entity search can be personalized, explicitly ask Shopify
       for that same query inside the preferred family. The original query is
       still always fetched and remains the relevance boundary. */
    if (context.usedHistoryFamily && context.preferredFamilyKey) {
      const family = familyRule(context.preferredFamilyKey);
      if (family) {
        push(`${context.rawQuery} ${family.query}`.trim(), 'history-refinement');
        if (context.seriesNameQuery && context.seriesCanonical) {
          push(`${context.seriesCanonical} ${family.query}`.trim(), 'history-canonical');
        }
      }
    }

    return variants.slice(0, 7);
  };

  const mergeProducts = groups => {
    const map = new Map();
    groups.flat().forEach(product => {
      const key = productKey(product);
      if (!key) return;
      const existing = map.get(key);
      if (!existing) {
        map.set(key, product);
        return;
      }
      if (product.bestSeller) {
        existing.bestSeller = true;
        existing.bestSellerRank = product.bestSellerRank;
      }
      if (!existing.image && product.image) existing.image = product.image;
      if (!existing.price && product.price) existing.price = product.price;
      if (!existing.type && product.type) existing.type = product.type;
      if (!existing.tags && product.tags) existing.tags = product.tags;
      if (!existing.series && product.series) existing.series = product.series;
      if (!existing.family && product.family) existing.family = product.family;
    });
    return Array.from(map.values());
  };

  const buildSuggestions = (context, rankedProducts) => {
    const suggestions = [];
    const push = (label, query) => {
      if (!label || !query) return;
      if (suggestions.some(item => normalize(item.label) === normalize(label))) return;
      suggestions.push({ label, query });
    };

    if (context.seriesKey) {
      const series = seriesRule(context.seriesKey);
      const primaryFamily = familyRule(context.effectiveFamilyKey);
      if (series && primaryFamily) push(`${series.label} ${primaryFamily.label}`, `${series.canonical} ${primaryFamily.query}`);

      const rankedFamilies = [];
      rankedProducts.forEach(product => {
        if (product.series !== context.seriesKey || !product.family) return;
        if (!rankedFamilies.includes(product.family)) rankedFamilies.push(product.family);
      });

      const fallbackFamilies = ['tshirt', 'hoodie', 'cosplay', 'figures', 'sweater', 'jersey'];
      unique([...rankedFamilies, ...fallbackFamilies]).forEach(key => {
        if (suggestions.length >= 4) return;
        const family = familyRule(key);
        if (!family || (primaryFamily && family.key === primaryFamily.key)) return;
        push(`${series.label} ${family.label}`, `${series.canonical} ${family.query}`);
      });
    } else if (context.effectiveFamilyKey) {
      const family = familyRule(context.effectiveFamilyKey);
      if (family) push(family.label, family.query);
    }

    if (!suggestions.length) {
      ['tshirt', 'hoodie', 'cosplay', 'sweater'].forEach(key => {
        const family = familyRule(key);
        if (family) push(family.label, family.query);
      });
    }

    return suggestions.slice(0, 4);
  };

  const rememberSearch = (query, context = null) => {
    const ctx = context || getQueryContext(query);
    const state = readState();
    state.seriesWeights = state.seriesWeights || {};
    state.queryHistory = Array.isArray(state.queryHistory) ? state.queryHistory : [];
    if (ctx.seriesKey) addWeight(state.seriesWeights, ctx.seriesKey, 0.35);
    if (ctx.explicitFamilyKey) addWeight(state.familyWeights || (state.familyWeights = {}), ctx.explicitFamilyKey, 0.25);
    const entry = { query: String(query || '').trim(), series: ctx.seriesKey, family: ctx.explicitFamilyKey, ts: Date.now() };
    state.queryHistory = [entry].concat(state.queryHistory.filter(item => normalize(item?.query) !== normalize(entry.query))).slice(0, 60);
    writeState(state);
  };

  const rememberSearchClick = (productInput, context = {}) => {
    const product = normalizeProduct(productInput, 'click', 0);
    const state = readState();
    state.seriesWeights = state.seriesWeights || {};
    state.familyWeights = state.familyWeights || {};
    state.tokenWeights = state.tokenWeights || {};
    if (product.family) addWeight(state.familyWeights, product.family, 1.6);
    if (product.series) addWeight(state.seriesWeights, product.series, 1.8);
    tokenize(product.title).slice(0, 8).forEach(token => addWeight(state.tokenWeights, token, 0.35, 40));
    if (product.id) {
      state.catalog = state.catalog || {};
      state.catalog[product.id] = Object.assign({}, state.catalog[product.id] || {}, product, { ts: Date.now() });
    }
    state.signals = state.signals || {};
    state.signals[`search-click:${product.id || product.handle || normalize(product.title)}`] = Date.now();
    if (context?.seriesKey) addWeight(state.seriesWeights, context.seriesKey, 0.5);
    writeState(state);
  };

  const search = async (query, options = {}) => {
    const context = getQueryContext(query, options);
    const signal = options.signal;
    const resultLimit = Math.max(3, Math.min(20, Number(options.limit) || 6));
    const fetchLimit = Math.min(50, Math.max(24, resultLimit * 6));

    const requests = [];

    /* Ask both Shopify search systems for the literal customer query. */
    requests.push(
      fetchPredictive(context.rawQuery, signal, fetchLimit)
        .then(items => items.map((p, i) => normalizeProduct(p, 'predictive', i)))
    );

    buildQueryVariants(context).forEach(({ query: variantQuery, source }, variantIndex) => {
      requests.push(
        fetchSearch(variantQuery, signal, fetchLimit)
          .then(items => items.map((p, i) =>
            normalizeProduct(p, source, i + variantIndex * 0.01)
          ))
      );
    });

    /* Brand-new shopper + plain anime-name search:
       intersect the store's bestseller ordering with this anime's relevance pool.
       This is NOT generic bestseller filler. Unrelated anime/products are removed
       by the same query-relevance boundary below. */
    if (context.coldStartAnimeBestsellers) {
      const bestSellerHandle = String(options.bestSellerHandle || '').trim();
      requests.push(
        fetchBestSellers(bestSellerHandle, signal)
          .then(items => items.map((p, i) => normalizeProduct(p, 'bestseller', i)))
      );
    }

    const settled = await Promise.all(requests);
    const merged = mergeProducts(settled);

    merged.forEach(product => {
      const ranked = scoreCandidate(product, context);
      product._score = ranked.score;
      product._queryTier = ranked.relevance.tier;
      product._anchorHits = ranked.relevance.anchorHits;
      product._anchorCoverage = ranked.relevance.anchorCoverage;
      product._literalTier = ranked.relevance.literalTier;
      product._titleMatched = ranked.relevance.titleMatched;
    });

    /* First establish the relevance pool. History is never allowed to bring
       an unrelated product into this pool. */
    merged.sort((a, b) =>
      b._queryTier - a._queryTier ||
      b._score - a._score ||
      a.sourceIndex - b.sourceIndex
    );

    const anchors = context.anchorTokens || [];
    const hasAnchorMatch = anchors.length > 0 && merged.some(product => product._anchorHits > 0);
    const strongestTier = merged.reduce((max, product) => Math.max(max, product._queryTier || 0), 0);

    let minimumTier = 48;
    if (strongestTier >= 76) minimumTier = 70;
    else if (strongestTier >= 58) minimumTier = 58;

    let ranked = merged.filter(product => {
      if ((product._queryTier || 0) < minimumTier) return false;

      /* A specific character/faction/entity such as Akatsuki remains literal.
         Generic Naruto products cannot replace real Akatsuki matches. */
      if (context.queryIntent === 'series-entity' && hasAnchorMatch && product._anchorHits <= 0) {
        return false;
      }

      return true;
    });

    /* Cold-start anime ordering:
       A shopper with no learned family preference gets the best-selling products
       from the searched anime first. Bestseller rank is used only after the
       product has already passed the anime/query relevance filter. */
    if (context.coldStartAnimeBestsellers && context.seriesKey && ranked.length) {
      const isAnimeBestSeller = product =>
        Boolean(product.bestSeller && product.series === context.seriesKey);

      if (ranked.some(isAnimeBestSeller)) {
        ranked.sort((a, b) =>
          Number(isAnimeBestSeller(b)) - Number(isAnimeBestSeller(a)) ||
          (
            isAnimeBestSeller(a) && isAnimeBestSeller(b)
              ? (Number(a.bestSellerRank ?? 999999) - Number(b.bestSellerRank ?? 999999))
              : 0
          ) ||
          b._queryTier - a._queryTier ||
          b._score - a._score ||
          a.sourceIndex - b.sourceIndex
        );
      }
    }

    /* Conditional personalization:
       - Anime-name query (Naruto/JJK/HxH/etc.): preferred family may lead all
         products from the correct anime.
       - Entity query (Akatsuki/Gojo/etc.): preferred family leads only when a
         product in that family actually contains the entity query in its title.
       - If there is no such preferred-family match, keep the normal query order.
       - Generic category/literal searches do not use browsing history. */
    if (context.usedHistoryFamily && context.preferredFamilyKey && ranked.length) {
      const preferredKey = context.preferredFamilyKey;
      const qualifiesForHistoryLead = product => {
        if (product.family !== preferredKey) return false;
        if (context.queryIntent === 'series-name') {
          return !context.seriesKey || product.series === context.seriesKey;
        }
        if (context.queryIntent === 'series-entity') {
          return Boolean(product._titleMatched && product._anchorHits > 0);
        }
        return false;
      };

      const hasPreferredMatches = ranked.some(qualifiesForHistoryLead);

      if (hasPreferredMatches) {
        ranked.sort((a, b) =>
          Number(qualifiesForHistoryLead(b)) - Number(qualifiesForHistoryLead(a)) ||
          b._queryTier - a._queryTier ||
          b._score - a._score ||
          a.sourceIndex - b.sourceIndex
        );
      }
    }

    const products = ranked.slice(0, resultLimit).map(product => {
      const clone = Object.assign({}, product);
      delete clone._score;
      delete clone._queryTier;
      delete clone._anchorHits;
      delete clone._anchorCoverage;
      delete clone._literalTier;
      delete clone._titleMatched;
      return clone;
    });

    const suggestions = buildSuggestions(context, ranked);
    rememberSearch(query, context);

    return { products, suggestions, context: Object.assign({}, context, { state: undefined }) };
  };

  const publicApi = {
    search,
    getQueryContext,
    classifySearchSeries: value => classifySeriesText(value)?.key || '',
    classifySearchFamily: value => classifyFamilyText(value)?.key || '',
    rememberSearch,
    rememberSearchClick,
    getSearchProfile: () => {
      const state = readState();
      return {
        familyWeights: Object.assign({}, state.familyWeights || {}),
        seriesWeights: Object.assign({}, state.seriesWeights || {}),
        tokenWeights: Object.assign({}, state.tokenWeights || {}),
        recentSearches: (state.queryHistory || []).slice(0, 12),
        recentViews: (state.views || []).slice(0, 12)
      };
    }
  };

  window.SkaiiyAI = Object.assign(window.SkaiiyAI || {}, publicApi);
  window.dispatchEvent(new CustomEvent('skaiiy:search-ai:ready', { detail: { version: '2.3.0-anime-cold-start-bestsellers' } }));
})();
